import get from 'lodash/get'
import {mapGetters} from 'vuex'
import {InstructorAbilities} from '@/components/mixins'

const ApplicationProfession = {
  mixins: [InstructorAbilities],

  computed: {
    ...mapGetters('application', [
      'selectedApplication',
      'applicationProfession',
      'applicationCompany',
      'applicationWorkplace',
      'applicationEmployee',
      'applicationCompanyEmployments',
      'applicationDepartment',
      'applicationDepartments'
    ]),
    ...mapGetters('basic', [
      'basicProfessions',
      'getEmploymentTypeNameById',
      'basicEmploymentTypes',
      'hasProfessionOrientations',
      'basicStates',
      'getProfessionById'
    ]),

    instructorHaveCertificate() {
      const professionId = get(this, 'applicationProfession.id', -1)
      const instructor = this.applicationCompanyEmployments.find(emp => emp.id === this.application.instructorId)
      const machineQualificationIds = this.professionOrientationsArr

      const canBeInstructorInGu = this.haveCertificates(instructor, professionId, machineQualificationIds, true)

      return canBeInstructorInGu
    },

    orientations() {
      const prof = this.applicationProfession
      if (prof && prof.machineOrientations) {
        return prof.machineOrientations.map(o => {
          return {value: o.id, text: o.name, defaultIncluded: o.isDefaultIncluded}
        })
      }
    }
  }
}

export default ApplicationProfession
